import { render } from "./CountrySwitch.vue?vue&type=template&id=5b8c7788"
import script from "./CountrySwitch.vue?vue&type=script&lang=js"
export * from "./CountrySwitch.vue?vue&type=script&lang=js"

import "./CountrySwitch.vue?vue&type=style&index=0&id=5b8c7788&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__